import i18next from 'i18next';

import {
  api,
  IAssetOrderItemsBE,
  IEditOrderParams,
  IGetAssetOrderMetricsParams,
  IOrderItemsBE,
  IOrderMetricsBE,
} from '@trader/api';
import { devLoggerService } from '@trader/services';

import { getRootInstance } from '../../configureStore/configureStore';
import { createThunk } from '../../utils/asyncModel';
import { ordersMetricsSchema } from './schemas';

export const getOrdersMetricsAsync = createThunk<
  {
    symbol?: IGetAssetOrderMetricsParams['symbol'];
    shouldClearBeforeMerge?: boolean;
  },
  void
>(
  options =>
    async function getOrdersMetrics(this: unknown, _options, _flow) {
      try {
        const { symbol, shouldClearBeforeMerge = false } = options || {};
        const root = getRootInstance();

        const res = symbol
          ? await api.Trading.getAssetOrdersMetrics({ symbol })
          : await api.Trading.getOrdersMetrics();

        const orders = symbol
          ? [(res as IAssetOrderItemsBE).order]
          : (res as IOrderItemsBE).orders;

        const metrics = (orders || []).map(o =>
          o.orderMetrics.map(m => ({
            ...m,
            symbol: o.symbol,
            pipSize: o.pipSize,
            iconUrl: o.iconUrl,
          }))
        );
        const ordersMetrics = metrics.flat(1);
        root.entities.normalizeMerge(
          ordersMetrics,
          ordersMetricsSchema,
          shouldClearBeforeMerge
        );
      } catch (e) {
        devLoggerService.error('Error in getOrdersMetricsAsync', e);
      }
    }
);

export const editOrderAsync = createThunk<IEditOrderParams, void>(
  body =>
    async function editOrder(this: unknown, _options, _flow) {
      const root = getRootInstance();

      await api.Trading.editOrder(body, _options);
      root.ui.modal.close();
      root.entities.ordersMetrics.getOrdersMetricsAsync.run();
      root.notifications.add({
        message: i18next.t('NOTIFICATIONS.ORDER_HAS_BEEN_EDITED'),
        options: {
          variant: 'success',
        },
      });
    }
);
export const cancelOrderAsync = createThunk<IOrderMetricsBE['orderId'], void>(
  orderId =>
    async function cancelOrder(this: unknown, _options, _flow) {
      const root = getRootInstance();

      await api.Trading.cancelOrder(orderId, _options);
      root.entities.ordersMetrics.delete(orderId);
      root.ui.modal.close();
      root.notifications.add({
        message: i18next.t('NOTIFICATIONS.ORDER_HAS_BEEN_CANCELED'),
        options: {
          variant: 'success',
        },
      });
    }
);
